import { HttpContextToken } from '@angular/common/http';

export const BYPASS_AUTH_INTERCEPTOR = new HttpContextToken<boolean>(() => false);

export const HTTP_ERROR_HANDLED = new HttpContextToken<boolean>(() => false);
